import { companySelfDeleteApi } from "src/domain/api/company/companySelfDeleteApi"

type PayloadShape = Parameters<typeof companySelfDeleteApi>[0]

export async function companySelfDeleteService(payload: PayloadShape, token: string) {
	return await companySelfDeleteApi(payload, token)
}
